import { ReactElement, useId } from 'react';
import { InkFinderLink, LABEL_TYPE, STYLE_TYPE } from '@client/common/components/InkFinderLink';
import { useDeviceType } from '@client/common/hooks';
import { isMobile } from '@client/common/utils/env';
import { Column } from '@lib/components/PrimaryLayout/Column';
import { Tabs } from 'b2b-components/theme/components/Tabs';
import { ProductReportForm } from '../ProductReportForm';
import { Props } from './ProductDetails.types';
import './ProductDetails.scss';

export const ProductDetails = ({
  columnLeft,
  columnRight,
  isInkFinderLinkDisplayed,
}: Props): ReactElement => {
  const deviceType = useDeviceType();
  const ids = {
    leftColumn: useId(),
    rightColumn: useId(),
  };

  if (columnLeft.length === 0) {
    return (
      <div>
        <Tabs tabId={ids.leftColumn} deviceType={deviceType}>{columnRight}</Tabs>
        {isInkFinderLinkDisplayed && <InkFinderLink labelType={LABEL_TYPE.long} styleType={STYLE_TYPE.big} />}
      </div>
    );
  }

  return !isMobile(deviceType) ? (
    <Column
      left={(
        <div
          data-testid='productDetailsLeftColumn'
          className='ProductContent-Column--Left'
        >
          <Tabs tabId={ids.leftColumn} deviceType={deviceType}>{columnLeft}</Tabs>
          <ProductReportForm />
        </div>
      )}
      right={(
        <div
          data-testid='productDetailsRightColumn'
          className='ProductContent-Column--Right'
        >
          <Tabs tabId={ids.rightColumn} deviceType={deviceType}>{columnRight}</Tabs>
          {isInkFinderLinkDisplayed && <InkFinderLink labelType={LABEL_TYPE.long} styleType={STYLE_TYPE.big} />}
        </div>
      )}
    />
  ) : (
    <div className="ProductContent--Split">
      <Tabs tabId={ids.rightColumn} deviceType={deviceType}>
        {[...columnLeft, ...columnRight]}
      </Tabs>
      {isInkFinderLinkDisplayed && <InkFinderLink labelType={LABEL_TYPE.long} styleType={STYLE_TYPE.big} />}
      <ProductReportForm />
    </div>
  );
};
